/**
 * Parse a PEM-encoded public key into an ArrayBuffer.
 */
function pemToArrayBuffer(pem: string): ArrayBuffer {
  const base64 = pem
    .replace(/\\r\\n|\\n/g, "\n")
    .replace(/-----BEGIN [A-Z ]+-----/, "")
    .replace(/-----END [A-Z ]+-----/, "")
    .replace(/\s/g, "")
  const binary = atob(base64)
  const buffer = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i++) {
    buffer[i] = binary.charCodeAt(i)
  }
  return buffer.buffer
}

/**
 * Encrypt a plaintext string with an RSA public key (PEM) using RSA-OAEP with SHA-256.
 * Returns the encrypted data as a base64 string.
 */
export async function encryptCredentials(
  publicKeyPem: string,
  payload: string,
): Promise<string> {
  const keyData = pemToArrayBuffer(publicKeyPem)
  const publicKey = await crypto.subtle.importKey(
    "spki",
    keyData,
    { name: "RSA-OAEP", hash: "SHA-256" },
    false,
    ["encrypt"],
  )
  const encrypted = await crypto.subtle.encrypt(
    { name: "RSA-OAEP" },
    publicKey,
    new TextEncoder().encode(payload),
  )
  const bytes = new Uint8Array(encrypted)
  let binary = ""
  for (const byte of bytes) {
    binary += String.fromCharCode(byte)
  }
  return btoa(binary)
}
